export default (context, inject) => {
  const getJsonLd = (json) => {
    return {
      __html: JSON.stringify(json)
    }
  }
  inject('getJsonLd', getJsonLd)
}
